import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import Translations from './components/Translations';
import LoginForm from './components/LoginForm';
// import FormPlayground from "./components/FormPlayground";
import Settings from './components/Settings';
import Layout from './Layout';
import useAuthContext from './auth/useAuthContext';
import useProjects from './data/useProjects';
import './styles.css';
import useUser from './data/useUser';

function App() {
  const { user } = useAuthContext();
  const {
    projects, currentProject, setCurrentProject, deleteProject,
  } = useProjects({ user });
  const { data } = useUser({ user });
  console.log('data from user', data && data.item?.Items[0]?.currentProject);
  const cr = data && data.item?.Items[0]?.currentProject;
  useEffect(() => {
    if (cr && projects) {
      const projectExists = projects.some((project) => project.project === cr);
      if (projectExists) {
        setCurrentProject(cr);
      } else {
        setCurrentProject(null);
      }
    }
  }, [cr, projects, setCurrentProject]);
  // console.log(user);
  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <Layout
      projects={projects}
      currentProject={currentProject}
      setCurrentProject={setCurrentProject}
      deleteProject={deleteProject}
    >
      <BrowserRouter>
        <Routes>
          <Route
            path='/'
            element={(
              <Translations
                currentProject={currentProject}
                setCurrentProject={setCurrentProject}
              />
            )}
          />
          <Route
            index
            element={(
              <Translations
                currentProject={currentProject}
                setCurrentProject={setCurrentProject}
              />
            )}
          />
          <Route path='/settings' element={<Settings />} />
          <Route path='/login' element={<LoginForm />} />
        </Routes>
      </BrowserRouter>
    </Layout>
  );
}

export default App;
